import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import FormLayoutTwo from "../../../../Core/Layout/FormLayoutTwo";
import Button from "../../../../Core/Button/Button";
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import { usePageState } from "../../../../Hook/usePageState";
import SelectSearch from "../../../../Core/Fields/Floating/SelectSearch";
import Date from "../../../../Core/Fields/Floating/Date";
import Header from "../../../../Components/Header";
import GetIcon from "../../../../utils/Icon";
import ConfigureColumns from '../../../Outbound/SalesInvoice/Create-Sales-Invoice/Components/ConfigureColumns'

import printerimg from "../../../../assets/print.png"

const NewQualityAction = () => {
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [ptype, setptype] = useState("Error");
  const [showError, setShowError] = useState(false);

  
  const pageStateDefault = {
    tab: 1,
    goal: "",
    actionDate: "",
    status: "",
    review: "",
    feedback: "",
    procedure: "",
  };

  const [pageState, setPageState] = usePageState(
    "New Quality Action",
    pageStateDefault
  );

  const [actionRows, setActionRows] = useState([
    { Problem: '', Resolution: '', Status: 'Open', Responsible: '', CompletionBy: '' }
  ])

  const initialColumns = [
    { key: 'checkbox', name: '', width: '4%', selected: true },
    { key: 'slno', name: 'Sl No.', width: '8%', selected: true },
    { key: 'Problem', name: 'Problem', selected: true },
    { key: 'Resolution', name: 'Resolution', selected: true },
    { key: 'Status', name: 'Status', selected: true },
    { key: 'Responsible', name: 'Responsible', selected: true },
    { key: 'CompletionBy', name: 'Completion By', selected: true },
    { key: 'setting', name: 'Setting', width: '6%', selected: true }
  ]

  const [columns, setColumns] = useState(initialColumns)
  const [showColumnConfig, setShowColumnConfig] = useState(false)
  const [showEditModal, setShowEditModal] = useState(false)
  const [editingRow, setEditingRow] = useState(null)
  const [selectedRows, setSelectedRows] = useState([])
  const [selectAll, setSelectAll] = useState(false)
  const visibleColumns = columns.filter((column) => column.selected)

  const { tab, goal, actionDate, status, review, feedback, procedure } =
    pageState;


  const goalOptions = [
    { label: "+ Create New Quality Goal" },
    { label: "Qty-goal-01", value: "Qty-goal-01" },
    { label: "Qty-goal-02", value: "Qty-goal-02" },
    { label: "Qty-goal-03", value: "Qty-goal-03" },
  ];

  const statusOptions = [
    { label: "Open", value: "Open" },
    { label: "In Progress", value: "In Progress" },
    { label: "Closed", value: "Closed" },
  ];

  const reviewOptions = [
    { label: "Review-01", value: "Review-01" },
    { label: "Review-02", value: "Review-02" },
  ];

  const feedbackOptions = [
    { label: "Feedback-01", value: "Feedback-01" },
    { label: "Feedback-02", value: "Feedback-02" },
  ];

  const procedureOptions = [
    { label: "Procedure-01", value: "Procedure-01" },
    { label: "Procedure-02", value: "Procedure-02" },
  ];

  const handleInputChange = (field, value) => {
    setPageState({ ...pageState, [field]: value });
  };

  const handleActionChange = (index, field, value) => {
    setActionRows((prev) =>
      prev.map((row, idx) => (idx === index ? { ...row, [field]: value } : row))
    )
  }

  const handleAddActionRow = () => {
    setActionRows((prev) => [...prev, { Problem: '', Resolution: '', Status: 'Open', Responsible: '', CompletionBy: '' }])
  }

  const handleRemoveActionRow = (index) => {
    setActionRows((prev) => (prev.length === 1 ? prev : prev.filter((_, idx) => idx !== index)))
  }

  const handleDeleteSelectedRows = () => {
    setActionRows((prev) => prev.filter((_, idx) => !selectedRows.includes(idx)))
    setSelectedRows([])
    setSelectAll(false)
  }

  const handleSaveColumns = (updatedColumns) => {
    setColumns(updatedColumns)
    setShowColumnConfig(false)
  }

  const handleEditRow = (index) => {
    setEditingRow({ ...actionRows[index], index })
    setShowEditModal(true)
  }

  const handleSaveEdit = () => {
    const updatedRows = [...actionRows]
    updatedRows[editingRow.index] = {
      Problem: editingRow.Problem,
      Resolution: editingRow.Resolution,
      Status: editingRow.Status,
      Responsible: editingRow.Responsible,
      CompletionBy: editingRow.CompletionBy
    }
    setActionRows(updatedRows)
    setShowEditModal(false)
    setEditingRow(null)
  }

  const handleSelectAll = () => {
    const newSelectAll = !selectAll
    setSelectAll(newSelectAll)
    if (newSelectAll) {
      setSelectedRows(actionRows.map((_, index) => index))
    } else {
      setSelectedRows([])
    }
  }

  const handleRowSelect = (index) => {
    setSelectedRows(prev => {
      const newSelected = prev.includes(index)
        ? prev.filter(i => i !== index)
        : [...prev, index]
      setSelectAll(false)
      return newSelected
    })
  }

  const handleSubmit = async () => {
    console.log('Submitting:', { ...pageState, actionRows })
    setError('Quality Action created successfully!')
    setptype('Success')
    setShowError(true)
    setTimeout(() => {
      navigate('/master/quality-action-list/quality-action-list')
    }, 3000)
  }

 
  const EditActionModal = () => {
    if (!showEditModal || !editingRow) return null

    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          background: "rgba(0,0,0,0.4)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 2000
        }}
      >
        <div
          style={{
            width: "850px",
            maxHeight: "90vh",
            overflowY: "auto",
            background: "#fff",
            borderRadius: "8px",
            padding: "20px 24px",
            boxShadow: "0px 4px 18px rgba(0,0,0,0.25)"
          }}
        >
          {/* HEADER */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 style={{ fontWeight: 600, margin: 0 }}>Edit Action Details</h5>

            <div
              onClick={() => {
                setShowEditModal(false)
                setEditingRow(null)
              }}
              style={{ cursor: "pointer" }}
            >
              <GetIcon
                iconName="RxCross2"
                size={22}
              />
            </div>
          </div>

          {/* FORM FIELDS */}
          <div className="row" style={{ rowGap: "18px" }}>
            <div className="col-md-6">
              <label className="form-label fw-semibold">Problem</label>
              <input
                className="form-control"
                value={editingRow.Problem}
                onChange={(e) =>
                  setEditingRow({ ...editingRow, Problem: e.target.value })
                }
              />
            </div>

            <div className="col-md-6">
              <label className="form-label fw-semibold">Resolution</label>
              <input
                className="form-control"
                value={editingRow.Resolution}
                onChange={(e) =>
                  setEditingRow({ ...editingRow, Resolution: e.target.value })
                }
              />
            </div>

            <div className="col-md-6">
              <label className="form-label fw-semibold">Status</label>
              <select
                className="form-select"
                value={editingRow.Status}
                onChange={(e) =>
                  setEditingRow({ ...editingRow, Status: e.target.value })
                }
              >
                {statusOptions.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-6">
              <label className="form-label fw-semibold">Responsible</label>
              <input
                className="form-control"
                value={editingRow.Responsible}
                onChange={(e) =>
                  setEditingRow({ ...editingRow, Responsible: e.target.value })
                }
              />
            </div>

            <div className="col-md-12">
              <label className="form-label fw-semibold">Completion By</label>
              <input
                className="form-control"
                type="date"
                value={editingRow.CompletionBy}
                onChange={(e) =>
                  setEditingRow({ ...editingRow, CompletionBy: e.target.value })
                }
              />
            </div>
          </div>

          {/* FOOTER */}
          <div className="d-flex justify-content-end mt-4">
            <Button
              className="custom-btn-00989"
              iconName="LuSave"
              iconSize={12}
              onClick={handleSaveEdit}
              style={{ height: "32px", padding: "0px 14px" }}
            >
              Save Changes
            </Button>
            
          </div>
        </div>
      </div>
    )
  }

  // =============================
  // PAGE UI
  // =============================
  return (
    <>
      <Helmet>
        <title>New Quality Action</title>
      </Helmet>

      <Header />

      <FormLayoutTwo
        title="New Quality Action"
        breadcrumbs={[
          { label: "Quality Action" },
          {
            label: "Quality Action List",
            url: "/master/quality-action-list/quality-action-list",
          },
        ]}
        status="New"
        actionButtons={
          <>
            <Button
              className="custom-btn-00989"
              onClick={() =>
                navigate("/master/quality-review/quality-review-list")
              }
              style={{ gap: "2px", height: "28px" }}
            >
              Quality Review
            </Button>

            <Button
              className="custom-btn-00989"
              iconName="LuFilePlus2"
              style={{ gap: "2px", height: "28px" }}
              onClick={handleSubmit}
              iconSize={12}
            >
              Save
            </Button>

            <Button
                                        to="/brand/create-brand"
                                        className="px-2"
                                        imgSrc={printerimg}
                                        imgStyle={{ width: '21px' }}
                                    />
          </>
        }
      >

        {/* ======================= */}
        {/* EDIT MODAL HERE */}
        {/* ======================= */}
        {showEditModal && <EditActionModal />}

        {/* MAIN CONTENT */}
        <div className="" style={{ width: "100%", backgroundColor: "#fff" }}>
          <div className="col-12 p-0" style={{ backgroundColor: "#eff4f9" }}>
            <div className="d-flex justify-content-between align-items-end">
              <ul
                className="nav nav-tabs"
                style={{ border: "none", marginLeft: "16px" }}
              >
                <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                  <a
                    className={
                      tab === 1
                        ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
                        : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
                    }
                    onClick={() => setPageState({ ...pageState, tab: 1 })}
                    href="javascript:void(0);"
                  >
                    General Details
                  </a>
                </li>
              </ul>

              <div
                className="d-flex align-items-center mb-2 px-3"
                style={{ gap: "6px", fontSize: "12px", cursor: "pointer" }}
              >
                <GetIcon iconName="CgAttachment" size={14} color="#4B002B" />
                <span className="fw-semibold">Attachments</span>
              </div>
            </div>
          </div>

          {/* FORM BODY */}
          <div className="px-4 py-4">
            {tab === 1 && (
              <>
                <div className="w-[100%]" style={{ display: "flex", gap: "20px" }}>
                  <div
                    className="col-md-12 px-0"
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "20px",
                    }}
                  >
                    {/* LEFT BOX */}
                    <div
                      style={{
                        backgroundColor: "#EBE6FA",
                        borderRadius: "6px",
                        padding: "16px",
                        minHeight: "120px",
                        width:"50%",
                      }}
                    >
                      <p style={{ fontSize: "16px", fontWeight: 600 }}>Details</p>

                      <div className="d-flex" style={{ gap: "15px" }}>
                        <div style={{ flex: 1 }}>
                          <SelectSearch
                            label="Goal"
                            placeholder="Select Goal"
                            value={goal}
                            onChange={(v) => handleInputChange("goal", v)}
                            list={goalOptions}
                            getOptionLabel={(i) => i.label}
                            getOptionValue={(i) => i.value}
                          />
                        </div>

                        <div style={{ flex: 1 }}>
                          <Date
                            label="Action Date"
                            value={actionDate}
                            onChange={(e) =>
                              handleInputChange("actionDate", e.target.value)
                            }
                          />
                        </div>

                        <div style={{ flex: 1 }}>
                          <SelectSearch
                            label="Status"
                            placeholder="Select Status"
                            value={status}
                            onChange={(v) => handleInputChange("status", v)}
                            list={statusOptions}
                            getOptionLabel={(i) => i.label}
                            getOptionValue={(i) => i.value}
                          />
                        </div>
                      </div>
                    </div>

                    {/* RIGHT BOX */}
                    <div
  style={{
    backgroundColor: "#E3F5DF",
    borderRadius: "6px",
    padding: "16px",
    minHeight: "120px",
    width: "50%",
  }}
>
  <div
    className="d-flex flex-wrap"
    style={{ gap: "20px", rowGap: "20px" }}
  >
    {/* Review */}
    <div style={{ width: "48%" }}>
      <SelectSearch
        label="Review"
        placeholder="Select"
        value={review}
        onChange={(v) => handleInputChange("review", v)}
        list={reviewOptions}
        getOptionLabel={(i) => i.label}
        getOptionValue={(i) => i.value}
      />
    </div>

    {/* Goal */}
    <div style={{ width: "48%" }}>
      <SelectSearch
        label="Goal"
        placeholder="Select"
        value={goal}
        onChange={(v) => handleInputChange("goal", v)}
        list={goalOptions}
        getOptionLabel={(i) => i.label}
        getOptionValue={(i) => i.value}
      />
    </div>

    {/* Feedback */}
    <div style={{ width: "48%" }}>
      <SelectSearch
        label="Feedback"
        placeholder="Select"
        value={feedback}
        onChange={(v) => handleInputChange("feedback", v)}
        list={feedbackOptions}
        getOptionLabel={(i) => i.label}
        getOptionValue={(i) => i.value}
      />
    </div>

    {/* Procedure */}
    <div style={{ width: "48%" }}>
      <SelectSearch
        label="Procedure"
        placeholder="Select"
        value={procedure}
        onChange={(v) => handleInputChange("procedure", v)}
        list={procedureOptions}
        getOptionLabel={(i) => i.label}
        getOptionValue={(i) => i.value}
      />
    </div>
  </div>
</div>

                  </div>
                </div>

                {/* TABLE SECTION */}
                <div
                  className="mb-3"
                  style={{
                    border: '1px solid #DBDBDB',
                    borderRadius: '6px',
                    padding: '16px',
                    backgroundColor: '#fff'
                  }}
                >
                  <p className="mb-3" style={{ fontSize: '16px', fontWeight: 600 }}>Actions</p>

                  <div className="table-responsive">
                    <table className="table table-bordered mb-0">
                      <thead>
                        <tr>
                          {visibleColumns.map((column,index) => (
                            <th key={column.key} style={{ width: column.width || 'auto' }}>
                              {column.key === 'checkbox' ? (
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  checked={selectAll}
                                  onChange={handleSelectAll}
                                />
                              ) : column.key === 'setting' ? (
                                <div
                                  onClick={() => setShowColumnConfig(true)}
                                  style={{ cursor: 'pointer', textAlign: 'center' }}
                                >
                                  <GetIcon iconName="PiSlidersHorizontalBold" size={14} />
                                </div>
                              ) : column.name}
                            </th>
                          ))}
                        </tr>
                      </thead>

                      <tbody>
                        {actionRows.map((row, index) => (
                          <tr key={index}>
                            {visibleColumns.map((column) => {
                              if (column.key === 'checkbox') {
                                return (
                                  <td className="text-center">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      checked={selectedRows.includes(index)}
                                      onChange={() => handleRowSelect(index)}
                                    />
                                  </td>
                                )
                              }

                              if (column.key === "slno") {
                                const serial = String(index + 1).padStart(2, "0");
                                return <td className="text-center align-middle">{serial}</td>;
                              }


                              if (column.key === 'Problem' || column.key === 'Resolution' || column.key === 'Responsible') {
                                return (
                                  <td>
                                    <input
                                      className="form-control border-0 shadow-none"
                                      type="text"
                                      value={row[column.key]}
                                      onChange={(e) => handleActionChange(index, column.key, e.target.value)}
                                      placeholder={column.name}
                                      style={{ background: 'transparent' }}
                                    />
                                  </td>
                                )
                              }

                              if (column.key === 'CompletionBy') {
                                return (
                                  <td>
                                    <input
                                      className="form-control border-0 shadow-none"
                                      type="date"
                                      value={row.CompletionBy}
                                      placeholder="Completion By"
                                      onChange={(e) => handleActionChange(index, 'CompletionBy', e.target.value)}
                                      style={{ background: 'transparent' }}
                                    />
                                  </td>
                                )
                              }

                              if (column.key === 'Status') {
                                return (
                                  <td>
                                    <select
                                      className="form-select border-0 shadow-none"
                                      value={row.Status}
                                      onChange={(e) => handleActionChange(index, 'Status', e.target.value)}
                                      style={{ background: 'transparent' }}
                                    >
                                      {statusOptions.map((opt) => (
                                        <option key={opt.value} value={opt.value}>
                                          {opt.label}
                                        </option>
                                      ))}
                                    </select>
                                  </td>
                                )
                              }

                              if (column.key === 'setting') {
                                return (
                                  <td className="text-center">
                                    <div
                                      onClick={() => handleEditRow(index)}
                                      style={{ cursor: 'pointer' }}
                                    >
                                      <GetIcon
                                        iconName="MdOutlineEdit"
                                        size={14}
                                        style={{ color: '#82868C' }}
                                      />
                                    </div>
                                  </td>
                                )
                              }

                              return null
                            })}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <div className="d-flex" style={{ gap: '4px' }}>
                      {selectedRows.length > 0 && (
                        <Button
                          style={{
                            backgroundColor: "#FF5969",
                            color: "white",
                            display: "flex",
                            alignItems: "center",
                            gap: "4px"
                          }}
                          className="btn-danger"
                          onClick={handleDeleteSelectedRows}
                        >
                          <GetIcon
                          iconName="MdDeleteOutline" size={12} />
                          Delete
                        </Button>
                      )}
                      <Button
                        className="Addrowdesign"
                        iconName="FiPlus"
                        iconSize={12}
                        onClick={handleAddActionRow}
                        iconWrapperStyle={{
                          backgroundColor: '#F6D593',
                          padding: '1px',
                          display: 'flex'
                        }}
                      >
                        Add Row
                      </Button>
                    </div>

                    <span style={{ fontSize: '12px', color: '#270B79' }}>
                      Showing {actionRows.length ? 1 : 0} to {actionRows.length} of {actionRows.length} entries
                    </span>
                  </div>

                  <ConfigureColumns
                    show={showColumnConfig}
                    onClose={() => setShowColumnConfig(false)}
                    onSave={handleSaveColumns}
                    initialFields={columns}
                    title="Quality Action"
                    type="Quality Action"
                  />
                </div>
              </>
            )}
          </div>
        </div>

        <ApiResponseBox
          poptype={ptype}
          show={showError}
          errorMessage={error}
          onClose={() => setShowError(false)}
        />
      </FormLayoutTwo>
    </>
  );
};

export default NewQualityAction;
